// extracted by mini-css-extract-plugin
module.exports = {"scrollbox":"dynamic_scrollbox_3bDoN"};